"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = exports.Calendar = exports.assignEventIndices = exports.useCalendarNavigation = exports.CalendarPage = exports.CalendarHeader = exports.CalendarDayBar = exports.sameDay = void 0;
var tslib_1 = require("tslib");
var Preact = tslib_1.__importStar(require("preact"));
var hooks_1 = require("preact/hooks");
var preact_transitioning_1 = require("preact-transitioning");
require("./Calendar.sass");
var CalendarEvent_1 = tslib_1.__importDefault(require("./components/CalendarEvent"));
function HSVToRGB(hsv) {
    if (hsv === void 0) { hsv = { h: 0, s: 0, v: 0 }; }
    var r = 0, g = 0, b = 0;
    var i = Math.floor(hsv.h * 6);
    var f = hsv.h * 6 - i;
    var p = hsv.v * (1 - hsv.s);
    var q = hsv.v * (1 - f * hsv.s);
    var t = hsv.v * (1 - (1 - f) * hsv.s);
    switch (i % 6) {
        default: break;
        case 0:
            r = hsv.v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = hsv.v;
            b = p;
            break;
        case 2:
            r = p;
            g = hsv.v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = hsv.v;
            break;
        case 4:
            r = t;
            g = p;
            b = hsv.v;
            break;
        case 5:
            r = hsv.v;
            g = p;
            b = q;
            break;
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
function componentToHex(c) {
    var hex = Math.round(c).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function RGBToHex(rgb) {
    if (rgb === void 0) { rgb = { r: 0, g: 0, b: 0 }; }
    return '#' + componentToHex(rgb.r) + componentToHex(rgb.g) + componentToHex(rgb.b);
}
function HSVToHex(hsv) {
    if (hsv === void 0) { hsv = { h: 0, s: 0, v: 0 }; }
    return RGBToHex(HSVToRGB(hsv));
}
var mod = function (n, m) { return ((n % m) + m) % m; };
function sameDay(a, b) {
    return (a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate());
}
exports.sameDay = sameDay;
var monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];
function CalendarDayBar() {
    return (Preact.h("div", { class: 'Calendar-DayBar' },
        Preact.h("span", null, "Sunday"),
        Preact.h("span", null, "Monday"),
        Preact.h("span", null, "Tuesday"),
        Preact.h("span", null, "Wednesday"),
        Preact.h("span", null, "Thursday"),
        Preact.h("span", null, "Friday"),
        Preact.h("span", null, "Saturday")));
}
exports.CalendarDayBar = CalendarDayBar;
function CalendarHeader(_a) {
    var month = _a.month, year = _a.year, onNavigate = _a.onNavigate, disabled = _a.disabled;
    var interactive = 'window' in global;
    return (Preact.h("div", { class: 'Calendar-Header' },
        interactive && Preact.h("button", { class: 'Calendar-Button Previous', disabled: disabled, onClick: function () { return onNavigate(-1); } }, "Previous"),
        Preact.h("h3", null,
            monthNames[month],
            " ",
            year),
        interactive && Preact.h("button", { class: 'Calendar-Button Next', disabled: disabled, onClick: function () { return onNavigate(1); } }, "Next")));
}
exports.CalendarHeader = CalendarHeader;
function CalendarDate(props) {
    var events = props.events.map(function (evt) {
        var _a;
        if (!evt)
            return Preact.h("div", null);
        var event = evt.event, classes = evt.classes;
        var color = (_a = event.color) !== null && _a !== void 0 ? _a : props.categories[event.category].color;
        if (event.hideDate) {
            if (!props.showHidden)
                return null;
            else
                classes += ' Hidden';
        }
        if (props.hovered === event.ind)
            classes += ' Selected';
        return (Preact.h("button", { class: 'Calendar-Event ' + classes, style: color && { '--color': HSVToHex(color) }, onMouseOut: function () { return props.onHover(undefined); }, onMouseOver: function () { return props.onHover(event.ind); }, onClick: function () { return props.onClick(event.ind); } }, classes.indexOf('start') !== -1 && Preact.h(Preact.Fragment, null,
            Preact.h("div", { class: 'Calendar-EventColorIndicator' }),
            Preact.h("span", null, evt.event.name))));
    });
    return (Preact.h("div", { class: props.class },
        Preact.h("span", { class: 'Calendar-DayIndicator' }, props.date.getDate()),
        events));
}
function useEventCascade(weekStart, events) {
    var cascade = hooks_1.useMemo(function () {
        var weekEnd = new Date(weekStart.getTime());
        weekEnd.setDate(weekStart.getDate() + 7);
        var eventCascade = [];
        events.filter(function (event) {
            var endDate = new Date(event.endDate || event.startDate);
            return (event.startDate > +weekStart && event.startDate < +weekEnd) || (endDate > weekStart && endDate <= weekEnd);
        }).sort(function (a, b) { return ((a.endDate || a.startDate) - a.startDate > (b.endDate || b.startDate) - b.startDate) ? -1 : 1; })
            .forEach(function (event) {
            var startInd = Math.floor((event.startDate - +weekStart) / (1000 * 3600 * 24));
            var endInd = Math.floor(((event.endDate || event.startDate) - +weekStart) / (1000 * 3600 * 24));
            for (var i = 0; true; i++) {
                if (!eventCascade[i])
                    eventCascade[i] = [null, null, null, null, null, null, null];
                var start = Math.max(startInd, 0);
                var end = Math.min(endInd, 6);
                var conflicts = false;
                for (var x = start; x <= end; x++) {
                    if (eventCascade[i][x]) {
                        conflicts = true;
                        break;
                    }
                    ;
                }
                if (conflicts)
                    continue;
                for (var x = start; x <= end; x++)
                    eventCascade[i][x] = { event: event, classes: (x === start ? 'start' : '') + (x === end ? ' end' : '') };
                break;
            }
        });
        return eventCascade;
    }, [events, weekStart]);
    return cascade;
}
function CalendarRow(props) {
    var eventCascade = useEventCascade(new Date(props.weekStart.getTime()), props.events);
    var date = new Date(props.weekStart.getTime());
    var days = [];
    var currentDate = new Date();
    var _loop_1 = function (i) {
        var isCurrentMonth = date.getMonth() === props.month;
        var isCurrentDate = sameDay(date, currentDate);
        var dayClasses = 'Calendar-Day ' +
            (isCurrentDate ? ' CurrentDay' : '') +
            (isCurrentMonth ? ' CurrentMonth' : '');
        var dayEvents = eventCascade.map(function (row) { return row.filter(function (_, d) { return d === i; })[0]; });
        days.push(Preact.h(CalendarDate, { class: dayClasses, date: new Date(date.getTime()), events: dayEvents, categories: props.categories, hovered: props.hovered, showHidden: props.showHidden, onHover: props.onHover, onClick: props.onClick }));
        date.setDate(date.getDate() + 1);
    };
    for (var i = 0; i < 7; i++) {
        _loop_1(i);
    }
    return (Preact.h("div", { class: 'Calendar-Row' }, days));
}
function CalendarPage(props) {
    var _a;
    var monthDate = new Date();
    monthDate.setMonth(props.month, 1);
    monthDate.setFullYear(props.year);
    var rows = [];
    var firstDayOfMonth = monthDate.getDay();
    for (var i = 1; true; i += 7) {
        var day = i - firstDayOfMonth;
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setMonth(props.month, 1);
        date.setFullYear(props.year);
        date.setDate(day);
        if ((date.getMonth() > props.month && date.getFullYear() >= props.year) || date.getFullYear() > props.year)
            break;
        rows.push(Preact.h(CalendarRow, { month: props.month, weekStart: date, events: props.events, categories: props.categories, hovered: props.hovered, showHidden: props.showHidden, onHover: props.onHover, onClick: props.onClick }));
    }
    return (Preact.h("div", { class: ('Calendar-Page ' + ((_a = props.className) !== null && _a !== void 0 ? _a : '')).trim(), key: props.month }, rows));
}
exports.CalendarPage = CalendarPage;
function useCalendarNavigation() {
    var _a = hooks_1.useState(function () { return new Date().getMonth(); }), month = _a[0], setMonth = _a[1];
    var _b = hooks_1.useState(function () { return new Date().getFullYear(); }), year = _b[0], setYear = _b[1];
    var navigate = function (months) {
        setMonth(mod(month + months, 12));
        setYear(year + Math.floor((month + months) / 12));
    };
    return [month, year, navigate];
}
exports.useCalendarNavigation = useCalendarNavigation;
function assignEventIndices(events) {
    var i = 0;
    if (!events)
        events = [];
    return events.map(function (e) { return Object.assign({}, e, { ind: i++ }); });
}
exports.assignEventIndices = assignEventIndices;
function Calendar(props) {
    var _a = useCalendarNavigation(), month = _a[0], year = _a[1], navigate = _a[2];
    var events = hooks_1.useMemo(function () { return assignEventIndices(props.events); }, [props.events]);
    var _b = hooks_1.useState(undefined), hovered = _b[0], setHovered = _b[1];
    var _c = hooks_1.useState(undefined), selected = _c[0], setSelected = _c[1];
    return (Preact.h("div", { class: 'Calendar' },
        Preact.h(CalendarHeader, { month: month, year: year, onNavigate: navigate, disabled: selected !== undefined }),
        Preact.h("div", { class: 'Calendar-Body' },
            Preact.h(CalendarDayBar, null),
            Preact.h("div", { class: 'Calendar-PageWrap' },
                Preact.h(preact_transitioning_1.TransitionGroup, { duration: 300 },
                    Preact.h(preact_transitioning_1.CSSTransition, { key: month, classNames: 'Animate' },
                        Preact.h(CalendarPage, { month: month, year: year, events: events, categories: props.categories, hovered: hovered, showHidden: false, onHover: setHovered, onClick: setSelected })))),
            selected !== undefined &&
                Preact.h(CalendarEvent_1.default, { event: events[selected], onClose: function () { return setSelected(undefined); } }))));
}
exports.Calendar = Calendar;
exports.client = {
    identifier: 'Calendar',
    element: Calendar
};
